export const splitCoordinates = (coordinates: string) => coordinates.split(',').map(parseFloat);
